module.exports = __webpack_public_path__ + "static/img/today-best-pick.1954088.png";